module.exports = __webpack_public_path__ + "img/like.2775d0ff.svg";